import axios from 'axios'
import {ChatMessage, ChatRoom, CompanyChatOpenInfo, PopupComponent, Visitor} from '../types'
import {context} from "./context";

const axiosClient = axios.create({
    timeout: 10000,
    withCredentials: true
})
axiosClient.interceptors.request.use(config => {
    config.params = {
        ...(config.params ?? {}),
        ca_account_key: context.accountKey
    }
    return config
})

interface BackendResponse<T> {
    code: number
    data: T
    message?: string
}
interface ChatServerResponse<T> {
    resStatus: number
    resData: T
}

export const postInfo = (info: any, infoKey: 'USER_METADATA' | 'METADATA' | 'SYS_METADATA'): void => {
    axiosClient.post('/api/open/v1/chat/customInfo', info, { params: { infoKey } })
}

export const trackPage = async (payload: any) => {
    const res = await axiosClient.post<BackendResponse<number>>('/api/open/v1/analytics/report', {
        ...payload,
        behaviorCode: 'VISIT_PAGE'
    })
    if (res.data.code === 200) {
        return res.data.data
    } else {
        return undefined
    }
}
export const trackStayPage = async (payload: any) => {
    await axiosClient.post<BackendResponse<number>>('/api/open/v1/analytics/report', {
        ...payload,
        behaviorCode: 'STAY_PAGE'
    })
}


export const initAccount = async (userId?: string): Promise<Visitor | undefined> => {
    const res = await axiosClient.get<BackendResponse<Visitor>>('/api/open/v1/chat/companyAccount/init', {
        data: { extraId: userId }
    })
    if (res.data.code === 200) {
        const visitor = res.data.data
        context.accountKey = visitor.accountKey
        return visitor
    } else {
        console.log(res.data.message)
        return undefined
    }
}
export const initChat = async (classifyId?: number): Promise<ChatRoom | undefined> => {
    const res = await axiosClient.get<BackendResponse<ChatRoom>>('/api/open/v1/chat/chatRoom/init', {
        params: { classifyId }
    })
    if (res.data.code === 200) {
        return res.data.data
    } else {
        console.log(res.data.message)
        return undefined
    }
}

export const report = (component: PopupComponent, base: string, behaviorCode: string, data?: any) => {
  return axiosClient.post(`${base}/api/open/v1/analytics/report`, {
    type: 'popup',
    properties: {
      behaviorCode,
      componentId: component.componentId,
      url: window.location.href,
      data
    }
  })
}

export interface FormField {
    formFieldId: number
    showName: string
    fieldName: string
    required: boolean
    fieldType: number
    displayType: string
    regexpValidation: string
}
export interface FormSection {
    brief: string
    formFieldDTOS: FormField[]
    formFieldSectionId: number
    sectionName: string
    sort: number
}
export interface Form {
    formDesc: string
    formFieldSectionDTOS: FormSection[]
    formId: number
    websiteFormId: number
    formName: string
}
export const getForm = async (formId: number): Promise<Form | undefined> => {
    const res = await axiosClient.get<BackendResponse<{ form: Form }>>('/api/open/v1/account/getFormById', {
        params: {
            formId
        }
    })
    const result = res.data
    if (result.code === 200 && result.data) {
        return result.data.form
    } else {
        return undefined
    }
}

export const sendKefuNewsNotice = async ({ chatRoomId }: ChatRoom): Promise<void> => {
    await axiosClient.get<BackendResponse<any>>(`/api/open/v1/chat/${chatRoomId}/account/news`)
}

export const loadCompanyInfo = async (): Promise<CompanyChatOpenInfo | undefined> => {
    const res = await axiosClient.get<BackendResponse<CompanyChatOpenInfo>>('/api/open/v1/chat/companyInfo')
    const result = res.data
    if (result.code === 200 && result.data) {
        return result.data
    } else {
        return undefined;
    }
}
export const submitForm = async (websiteFormId: number, formData: FormData): Promise<void> => {
    const data = Object.fromEntries(formData) // submit as json
    const res = await axiosClient.post<BackendResponse<void>>('/api/open/v1/account/submitSurvey', data, {
        params: {
            websiteFormId
        },
    })
    if (res.data.code !== 200) {
        throw new Error(res.data.message)
    }
}
